import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  updateDoc,
  doc,
} from "firebase/firestore";
import { getDoc } from "firebase/firestore";

import { db } from "../firebase/config";

export const getPlans = async () => {
  const snapshot = await getDocs(collection(db, "subscriptionPlans"));

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const addPlan = async (data) => {
  return await addDoc(collection(db, "subscriptionPlans"), data);
};

export const deletePlan = async (id) => {
  return await deleteDoc(doc(db, "subscriptionPlans", id));
};

export const updatePlan = async (id, data) => {
  return await updateDoc(doc(db, "subscriptionPlans", id), data);
};

export const getPlanById = async (id) => {
  const snapshot = await getDoc(doc(db, "subscriptionPlans", id));

  if (!snapshot.exists()) {
    return null;
  }

  return {
    id: snapshot.id,
    ...snapshot.data(),
  };
};
